import React from "react";
import serviceJson from "../data/services";
import serviceJson2 from "../data/services1";
import bookkeeping from "../images/5.png";
import incometaxfiling from "../images/1.png";
import gstregistration from "../images/2.png";
import companyLaw from "../images/4.png";
import businessstartup from "../images/6.png";
import audit from "../images/3.png";

import '../styles/cover.css';
import '../styles/services.css';

const rootFolder = "../images";

export default class Services extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            services: serviceJson,
            services1: serviceJson2,
            iconImages: [],
            iconImages1: []
        };

        this.renderServices = this.renderServices.bind(this);
    }

    componentDidMount(){
        let images = [];
        images.push(incometaxfiling);
        images.push(gstregistration);
        images.push(audit);
        this.setState({iconImages: images});
        images = [];
        images.push(companyLaw);
        images.push(bookkeeping);
        images.push(businessstartup);
        this.setState({iconImages1: images});

    }

    componentWillReceiveProps(nextProps){

    }

    renderServices = (services, iconImages) => {
        return services.map((s, index) => {
            return (
            <div key={index} className="card bg-light text-dark card-custom">
                <img className="card-img" src={iconImages[index]} alt="Card image"/>
            </div>)
        })
    };

    render() {
        return (
                <div className="services-container">
                    <div className="servicesHeading padding-bottom">Services We Offer</div>
                    <div className="card-deck padding-bottom-more">{this.renderServices(this.state.services, this.state.iconImages)}</div>
                    <div className="card-deck">{this.renderServices(this.state.services1, this.state.iconImages1)}</div>
                </div>
        )
    }
}